export default __webpack_public_path__ + "static/media/ads.b7a39d0f.svg";